export default __webpack_public_path__ + "static/media/agregar-invitado.189931d9.svg";